import { createApp } from 'vue';
import EditRecordingDetails from './EditRecordingDetails.vue';

// Mount the EditRecordingDetails component
const mountEditRecordingDetails = () => {
  const el = document.createElement('div');
  el.id = 'edit-recording-details-app';
  document.body.appendChild(el);

  const app = createApp(EditRecordingDetails);
  app.mount('#edit-recording-details-app');
};

// Auto-mount on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountEditRecordingDetails);
} else {
  mountEditRecordingDetails();
}
